import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Layout } from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { euro, formatDate } from "@/lib/constants";
import { Ticket, Search } from "lucide-react";

export default function Bookings() {
  const [bookings, setBookings] = useState([]);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => { api.get("/bookings").then((r) => setBookings(r.data)); }, []);

  const list = q ? bookings.filter((b) => `${b.tipo} ${b.fornitore} ${b.trasferta} ${b.codice}`.toLowerCase().includes(q.toLowerCase())) : bookings;
  const totale = list.reduce((s, b) => s + Number(b.costo || 0), 0);

  return (
    <Layout>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h1 className="font-display text-3xl font-bold text-slate-900">Prenotazioni</h1>
          <p className="text-slate-500 mt-1">Vista centralizzata · Totale {euro(totale)}</p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input data-testid="bookings-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca prenotazione..." className="pl-9" />
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm">
        {list.length === 0 ? (
          <div className="p-12 text-center text-slate-400"><Ticket size={32} className="mx-auto mb-3 opacity-40" />Nessuna prenotazione.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-5 py-3">Tipo</th><th className="text-left px-5 py-3">Fornitore</th>
                <th className="text-left px-5 py-3">Trasferta</th><th className="text-left px-5 py-3">Codice</th>
                <th className="text-left px-5 py-3">Data</th><th className="text-right px-5 py-3">Costo</th>
              </tr>
            </thead>
            <tbody>
              {list.map((b, i) => (
                <tr key={b.id || b.trip_id} className="border-t border-slate-50 hover:bg-slate-50 cursor-pointer" data-testid={`booking-row-${b.id || b.trip_id}`} onClick={() => navigate(`/trasferte/${b.trip_id}`)}>
                  <td className="px-5 py-3 font-medium">{b.tipo}</td>
                  <td className="px-5 py-3 text-slate-600">{b.fornitore || "—"}</td>
                  <td className="px-5 py-3 text-slate-600">{b.trasferta}</td>
                  <td className="px-5 py-3 font-mono text-xs">{b.codice || "—"}</td>
                  <td className="px-5 py-3 text-slate-600">{formatDate(b.data)}</td>
                  <td className="px-5 py-3 text-right font-medium">{euro(b.costo)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </Layout>
  );
}
